import { useState } from 'react';
import cx from 'classnames';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';

import type { ArrayElement } from '@plone/types';

import styles from '@redturtle/qubicaamf-theme/components/Blocks/Accordion/styles.module.css';

import type { AccordionData } from '@redturtle/qubicaamf-theme/components/Blocks/Accordion/schema';
import PlusSVG from '@redturtle/qubicaamf-theme/components/Icons/PlusSVG';
import MinusSVG from '@redturtle/qubicaamf-theme/components/Icons/MinusSVG';

type Props = {
  data: ArrayElement<AccordionData['items']>;
};

export default function EditItem({ data }: Props) {
  const [collapsed, setCollapsed] = useState(true);

  // reference: https://www.w3.org/WAI/ARIA/apg/patterns/accordion/examples/accordion
  return (
    <div className={cx('block-accordion-item', styles.item)}>
      <h3 className={cx('block-accordion-item-title', styles.itemTitle)}>
        <button
          type="button"
          aria-expanded={!collapsed}
          aria-controls={'section-' + data['@id']}
          id={'accordion-' + data['@id']}
          onClick={() => setCollapsed(!collapsed)}
          className={cx('block-accordion-item-button', styles.button)}
        >
          {data.title}

          {collapsed ? <PlusSVG /> : <MinusSVG />}
        </button>
      </h3>
      <div
        id={'section-' + data['@id']}
        role="region"
        aria-labelledby={'accordion-' + data['@id']}
        hidden={collapsed}
        className={cx('block-accordion-item-text', styles.itemText)}
      >
        <TextBlockView data={{ value: data.text ?? {} }} />
      </div>
    </div>
  );
}
